import { MenuItem } from '.';

type MenuItemBagProperties = {
  observations: string;
  amount: number;
  bagItemId: string;
};

export type MenuItemWithDetails = MenuItem & {
  isPizzaItem: boolean;
  menuName: string;
};
export type MenuItemFavorited = MenuItemWithDetails & {
  originalMenuName: string;
  nameWithMenuLabel: string;
  isFavorited: boolean;
};

export type MenuItemWithDetailsOfBag = MenuItemWithDetails & MenuItemBagProperties;

export type MenuItemFavoritedOfBag = MenuItemFavorited & MenuItemBagProperties;

export class MenuItemTypeGuard {
  static isFavorited(arg: any): arg is MenuItemFavorited {
    return arg.isFavorited !== undefined;
  }

  static isFavoritedOfBag(arg: any): arg is MenuItemFavoritedOfBag {
    return arg.isFavorited !== undefined && arg.bagItemId !== undefined;
  }

  static isWithDetailsOfBag(arg: any): arg is MenuItemWithDetailsOfBag {
    return arg.bagItemId !== undefined;
  }
}
